import { RepositoriesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import { ApiCallError } from 'app/http/ApiCallError';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { repositoriesKeys } from 'app/queries/repositories/repositoriesKeys';
import type { TCall } from 'app/queries/types/TCall';
import { isUuid } from '../helpers/isUuid';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.organizationDetail>>;

export const createFetchRepositoryQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ organizationSlug, repositorySlug }], signal }: TParams) => {
    const fetchById = () =>
      call(() => cancelOnSignal(RepositoriesService.findOne({ repositoryId: repositorySlug }), signal));

    if (isUuid(repositorySlug)) {
      return fetchById();
    }

    try {
      return await call(() =>
        cancelOnSignal(RepositoriesService.findOneBySlug({ orgSlug: organizationSlug, slug: repositorySlug }), signal),
      );
    } catch (error) {
      if (error instanceof ApiCallError && error.status === 404) {
        return fetchById();
      }
      throw error;
    }
  };
